import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'rate',
    description:
      'Rate can help your organization develop a robust proposal to navigate the dynamic relationship with the federal government.',
    icon: 'rate',
    name: 'Rate',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: true,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
